import React, { useState } from 'react'
import down from "../assets/down.png"

function Selectcustoms({ placeholder }) {
    const [selectedOption, setSelectedOption] = useState('option1');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);
    }
    return (<>

        <div className="custom-select" style={{ position: "relative" }}>
            <select className='input3' style={{paddingLeft:"10px"}} value={selectedOption} onChange={handleSelectChange}>
                <option className='option1' value="option1" style={{fontSize:"16px",fontWeight:"400"}}>{placeholder}</option>

            </select>
            <div style={{ position: "absolute", top: "5px", right: "10px" }}>
                <img src={down} />
            </div>
        </div>




    </>

    )
}

export default Selectcustoms